<div class="page-container">
  <div class="page-header">
    <div class="header-content">
      <h1 class="page-title">Order Booking</h1>
      <p class="page-subtitle">Create and manage shipping orders</p>
    </div>
    <button *ngIf="isReadOnly" type="button" class="btn-edit-header" (click)="enableEditMode()">
      <mat-icon>edit</mat-icon>
      <span>Edit</span>
    </button>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="loading-overlay">
    <mat-spinner diameter="50" color="primary"></mat-spinner>
    <p class="loading-text">Processing...</p>
  </div>

  <div class="form-card" [class.loading]="isLoading">
    <!-- Customer Section -->
    <div class="section-card">
      <mat-accordion>
        <mat-expansion-panel
          [(expanded)]="customerExpanded"
          class="expansion-panel"
        >
          <mat-expansion-panel-header class="panel-header">
            <mat-panel-title>
              <div class="panel-title-content">
                <mat-icon class="section-icon">person</mat-icon>
                <span>Customer Information</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="panel-content">
            <div class="form-grid">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Customer Name</mat-label>
                <mat-select
                  [(value)]="customerSelectedValue"
                  (selectionChange)="onCustomerSelected($event)"
                  panelClass="custom-select-panel"
                  (openedChange)="onOpenedChange($event)"
                  [disabled]="isReadOnly"
                >
                  <mat-option class="search-option">
                    <input
                      #searchInput
                      type="text"
                      placeholder="Search customer..."
                      (input)="filterCustomerOptions($event)"
                      (click)="$event.stopPropagation()"
                      (mousedown)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation()"
                      class="search-input"
                      autocomplete="off"
                    />
                  </mat-option>
                  <mat-option
                    *ngFor="let option of filteredCustomerListOptions"
                    [value]="option"
                  >
                    {{ option.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Pickup Location</mat-label>
                <mat-select
                  [(value)]="pickUpLocationSelectedValue"
                  (selectionChange)="onCustomerLocationSelected($event)"
                  panelClass="custom-select-panel"
                  (openedChange)="onOpenedChange($event)"
                  [disabled]="isReadOnly"
                >
                  <mat-option class="search-option">
                    <input
                      #searchInput
                      type="text"
                      placeholder="Search location..."
                      (input)="filteredCustomerPickUpLocationOptions($event)"
                      (click)="$event.stopPropagation()"
                      (mousedown)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation()"
                      class="search-input"
                      autocomplete="off"
                    />
                  </mat-option>
                  <mat-option
                    *ngFor="
                      let option of filteredCustomerPickUpLocationListOptions
                    "
                    [value]="option"
                  >
                    {{ option.address }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Pickup Date</mat-label>
                <input
                  matInput
                  [(ngModel)]="pickupDate"
                  [matDatepicker]="pickupPicker"
                  (dateChange)="onPickupDateChange($event)"
                  [disabled]="isReadOnly"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="pickupPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #pickupPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div *ngIf="showPickUpContact" class="contact-table-wrapper">
              <div class="table-header-label">
                <mat-icon>contacts</mat-icon>
                <span>Pickup Contacts</span>
              </div>
              <table class="data-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Position</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of pickUpContactList">
                    <td>{{ data.name }}</td>
                    <td>{{ data.phone }}</td>
                    <td>{{ data.position }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!-- Consignee Section -->
    <div class="section-card">
      <mat-accordion>
        <mat-expansion-panel
          [(expanded)]="consigneeExpanded"
          class="expansion-panel"
        >
          <mat-expansion-panel-header class="panel-header">
            <mat-panel-title>
              <div class="panel-title-content">
                <mat-icon class="section-icon">local_shipping</mat-icon>
                <span>Consignee Information</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="panel-content">
            <div class="form-grid">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Consignee Name</mat-label>
                <mat-select
                  [(value)]="consigneeSelectedValue"
                  (selectionChange)="onConsigneeSelected($event)"
                  panelClass="custom-select-panel"
                  (openedChange)="onOpenedChange($event)"
                  [disabled]="isReadOnly"
                >
                  <mat-option class="search-option">
                    <input
                      #searchInput
                      type="text"
                      placeholder="Search consignee..."
                      (input)="filterConsigneeOptions($event)"
                      (click)="$event.stopPropagation()"
                      (mousedown)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation()"
                      class="search-input"
                      autocomplete="off"
                    />
                  </mat-option>
                  <mat-option
                    *ngFor="let option of filteredConsigneeListOptions"
                    [value]="option"
                  >
                    {{ option.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Delivery Location</mat-label>
                <mat-select
                  [(value)]="deliveryLocationSelectedValue"
                  (selectionChange)="onConsigneeLocationSelected($event)"
                  panelClass="custom-select-panel"
                  (openedChange)="onOpenedChange($event)"
                  [disabled]="isReadOnly"
                >
                  <mat-option class="search-option">
                    <input
                      #searchInput
                      type="text"
                      placeholder="Search location..."
                      (input)="filteredConsigneePickUpLocationOptions($event)"
                      (click)="$event.stopPropagation()"
                      (mousedown)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation()"
                      class="search-input"
                      autocomplete="off"
                    />
                  </mat-option>
                  <mat-option
                    *ngFor="
                      let option of filteredConsigneeDeliveryLocationListOptions
                    "
                    [value]="option"
                  >
                    {{ option.address }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Delivery Date</mat-label>
                <input
                  matInput
                  [(ngModel)]="deliveryDate"
                  [matDatepicker]="deliveryPicker"
                  [min]="pickupDate"
                  (dateChange)="onDeliveryDateChange($event)"
                  [disabled]="isReadOnly"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="deliveryPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #deliveryPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div *ngIf="showDeliveryContact" class="contact-table-wrapper">
              <div class="table-header-label">
                <mat-icon>contacts</mat-icon>
                <span>Delivery Contacts</span>
              </div>
              <table class="data-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Position</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of deliveryContactList">
                    <td>{{ data.name }}</td>
                    <td>{{ data.phone }}</td>
                    <td>{{ data.position }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!-- Commodity Section -->
    <div class="section-card">
      <mat-accordion>
        <mat-expansion-panel
          [(expanded)]="commodityExpanded"
          class="expansion-panel"
        >
          <mat-expansion-panel-header class="panel-header">
            <mat-panel-title>
              <div class="panel-title-content">
                <mat-icon class="section-icon">inventory_2</mat-icon>
                <span>Commodity Details</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="panel-content">
            <div class="scroll-hint">
              <mat-icon>swipe</mat-icon>
              <span>Scroll horizontally to see all fields</span>
            </div>

            <div class="commodity-table-wrapper">
              <table class="commodity-table">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Customer Ref <span class="required-asterisk">*</span></th>
                    <th>Description</th>
                    <th>Quantity</th>
                    <th>Packaging Type</th>
                    <th>Volume (M³)</th>
                    <th>Gross Weight (Kg)</th>
                    <th>Stackable</th>
                    <th>Dangerous</th>
                    <th>Temperature Control</th>
                    <th>Handling Type</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let dataCommodity of commodityTotals; let i = index"
                  >
                    <td>{{ i + 1 }}</td>
                    <td>
                      <input
                        matInput
                        [(ngModel)]="dataCommodity.customerRef"
                        placeholder="Customer Ref"
                        class="table-input"
                        required
                        [disabled]="isReadOnly"
                      />
                    </td>
                    <td>
                      <input
                        matInput
                        [(ngModel)]="dataCommodity.description"
                        placeholder="Description"
                        class="table-input"
                        [disabled]="isReadOnly"
                      />
                    </td>
                    <td>
                      <input
                        matInput
                        [(ngModel)]="dataCommodity.quantity"
                        placeholder="Quantity"
                        class="table-input"
                        type="number"
                        [disabled]="isReadOnly"
                      />
                    </td>
                    <td>
                      <select
                        [(ngModel)]="dataCommodity.packagingType"
                        class="table-select"
                        [disabled]="isReadOnly"
                      >
                        <option
                          *ngFor="let option of packagingTypeOptions"
                          [ngValue]="option"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <input
                        matInput
                        [(ngModel)]="dataCommodity.volume"
                        placeholder="Volume"
                        class="table-input"
                        type="number"
                        [disabled]="isReadOnly"
                      />
                    </td>
                    <td>
                      <input
                        matInput
                        [(ngModel)]="dataCommodity.grossWeight"
                        placeholder="Weight"
                        class="table-input"
                        type="number"
                        [disabled]="isReadOnly"
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        [(ngModel)]="dataCommodity.stackable"
                        class="table-checkbox"
                        [disabled]="isReadOnly"
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        [(ngModel)]="dataCommodity.dangerousFlag"
                        class="table-checkbox"
                        [disabled]="isReadOnly"
                      />
                    </td>
                    <td>
                      <select
                        [(ngModel)]="dataCommodity.temperatureControl"
                        class="table-select"
                        [disabled]="isReadOnly"
                      >
                        <option
                          *ngFor="let option of temperatureControlOptions"
                          [ngValue]="option"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <select
                        [(ngModel)]="dataCommodity.handlingType"
                        class="table-select"
                        [disabled]="isReadOnly"
                      >
                        <option
                          *ngFor="let option of handlingTypeOptions"
                          [ngValue]="option"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn-remove-table"
                        (click)="removeCommodity(i)"
                        *ngIf="commodityTotals.length > 1 && !isReadOnly"
                      >
                        <mat-icon>close</mat-icon>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="commodity-header" *ngIf="!isReadOnly">
              <span class="commodity-label"
                >Add more commodities for this order</span
              >
              <button type="button" class="btn-add" (click)="addCommodity()">
                <mat-icon>add</mat-icon>
                <span>Add Commodity</span>
              </button>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!-- Transport Section -->
    <div class="section-card transport-section">
      <mat-accordion>
        <mat-expansion-panel
          [(expanded)]="transportExpanded"
          class="expansion-panel"
        >
          <mat-expansion-panel-header class="panel-header">
            <mat-panel-title>
              <div class="panel-title-content">
                <mat-icon class="section-icon">directions_car</mat-icon>
                <span>Transport Details</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="panel-content">
            <div class="transport-columns">
              <!-- Left column: Number of Trucks Order + Types of Trucks Loaded -->
              <div class="transport-left">
                <div class="form-section">
                  <div class="section-label">Number of Trucks Order</div>
                  <mat-form-field
                    class="form-field full-width"
                    appearance="outline"
                    [class.truck-mismatch-field]="truckCountMismatch"
                  >
                    <mat-label>Total Trucks Required</mat-label>
                    <input
                      matInput
                      [(ngModel)]="totalTruckOrdered"
                      placeholder="Enter number of trucks"
                      [disabled]="isReadOnly"
                      (ngModelChange)="truckCountMismatch = false"
                    />
                    <mat-hint *ngIf="truckCountMismatch" class="truck-mismatch-hint">
                      Total does not match the sum of trucks in the list
                    </mat-hint>
                  </mat-form-field>
                </div>

                <form class="form-section" [formGroup]="orderTruckForm">
                  <div class="section-label">Types of Trucks Loaded</div>
                  <div formArrayName="truckOrdered" class="truck-list">
                    <div
                      *ngFor="let truck of truckOrdered.controls; let i = index"
                      [formGroupName]="i"
                      class="truck-item"
                    >
                      <div class="truck-grid">
                        <mat-form-field appearance="outline" class="form-field">
                          <mat-label>Truck Type</mat-label>
                          <mat-select
                            formControlName="truckType"
                            (openedChange)="onTruckTypeOpened($event, i)"
                            panelClass="custom-select-panel"
                            [disabled]="isReadOnly"
                          >
                            <mat-option>
                              <input
                                type="text"
                                placeholder="Search truck type..."
                                (input)="filterTruckTypesFunc($event, i)"
                                (click)="$event.stopPropagation()"
                                (mousedown)="$event.stopPropagation()"
                                (keydown)="$event.stopPropagation()"
                                class="search-input"
                                autocomplete="off"
                              />
                            </mat-option>
                            <mat-option
                              *ngFor="let option of filterTruckTypesList[i]"
                              [value]="option"
                            >
                              {{ option.name }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <mat-form-field class="form-field" appearance="outline">
                          <mat-label>Number of Truck</mat-label>
                          <input
                            matInput
                            formControlName="numberOfTruck"
                            placeholder="Enter quantity"
                            [disabled]="isReadOnly"
                            (input)="truckCountMismatch = false"
                          />
                        </mat-form-field>

                        <button
                          type="button"
                          class="btn-remove"
                          (click)="removeTruckType(i)"
                          *ngIf="truckOrdered.length > 1 && !isReadOnly"
                        >
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="section-header" *ngIf="!isReadOnly">
                    <div class="section-label"></div>
                    <button type="button" class="btn-add" (click)="addTruckType()">
                      <mat-icon>add</mat-icon>
                      <span>Add Truck</span>
                    </button>
                  </div>
                </form>
              </div>

              <!-- Right column: Assigned Trucks -->
              <div *ngIf="assignedTrucks.length > 0" class="form-section transport-right">
                <div class="section-label">Assigned Trucks</div>
                <table class="data-table">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Plate Number</th>
                      <th>Truck Type</th>
                      <th>Driver Name</th>
                      <th>Driver Phone</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let truck of assignedTrucks; let i = index">
                      <td>{{ i + 1 }}</td>
                      <td>{{ truck.plateNumber }}</td>
                      <td>{{ truck.truckType }}</td>
                      <td>{{ truck.driverName }}</td>
                      <td>{{ truck.driverPhone }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!-- Submit Button -->
    <div class="form-actions" *ngIf="!isReadOnly">
      <button type="submit" class="btn-draft" (click)="saveDraftButton()" *ngIf="isDraft || isEdit !== 'true'">
        <span>Draft</span>
      </button>
      <div style="margin-left: 30px"></div>
      <button type="submit" class="btn-submit" (click)="submitButton()">
        <mat-icon>check</mat-icon>
        <span>Submit Order</span>
      </button>
    </div>
  </div>
</div>
